import CardBanner1 from "../../assets/GrocerryAndEssentials.webp";
import CardBanner2 from "../../assets/PickupAndDrop.webp";
import CardBanner3 from "../../assets/Restaurants.jpg";
import CardBanner4 from "../../assets/FruitsAndVegetables.webp";
import ItemBanner1 from "../../assets/MeatAndFish.webp";
import ItemBanner2 from "../../assets/PetSupplies.webp";
import ItemBanner3 from "../../assets/Paan.webp";

import TopPicksBanner1 from "../../assets/d4b.webp";
import TopPicksBanner2 from "../../assets/ShelfLove.webp";
import TopPicksBanner3 from "../../assets/BiteOnTime.webp";
import TopPicksBanner4 from "../../assets/Packages.webp";

export const CARDS_DATA = [
  { id: "1", banner: { CardBanner1 } },
  { id: "2", banner: { CardBanner2 } },
  { id: "3", banner: { CardBanner3 } },
  { id: "4", banner: { CardBanner4 } },
];

export const ITEMS_DATA = [
  { id: "1", title: "Meat and Fish", banner: { ItemBanner1 } },
  { id: "2", title: "Pet Supplies", banner: { ItemBanner2 } },
  { id: "3", title: "Paan Shop", banner: { ItemBanner3 } },
];

export const TOPPICKS_DATA = [
  { id: "1", banner: { TopPicksBanner1 } },
  { id: "2", banner: { TopPicksBanner2 } },
  { id: "3", banner: { TopPicksBanner3 } },
  { id: "4", banner: { TopPicksBanner4 } },
];
